import { ServiceFetch } from '../service-fetch'

export default class ProductIncludeModel extends ServiceFetch {
    getProductIncludeBy = (data) => this.authFetch({
        url: 'product-include/getProductIncludeBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}